import { SupabaseTableBase } from '../../utils/SupabaseTableBase';
import { CallTranscriptMessage } from './types';

export class CallTranscriptMessageService extends SupabaseTableBase<CallTranscriptMessage> {
  constructor() {
    super('CallTransriptMessage');
  }

  async createTranscriptMessage(callId: string, message: string, author: string, datetime: string): Promise<CallTranscriptMessage | null> {
    try {
      const messageData = {
        callid: callId,  // Database uses lowercase 'callid'
        message,
        author,
        datetime
      };

      const result = await this.insertRecord(messageData);
      
      if (result.error) {
        console.error('Database error:', result.error);
        return null;
      }
      
      return result.data;
    } catch (error) {
      console.error('Error creating transcript message:', error);
      return null;
    }
  }

  async getTranscriptMessagesByCallId(callId: string): Promise<CallTranscriptMessage[]> {
    try {
      const result = await this.selectRecordsByColumn('callid', callId, {
        orderBy: 'datetime',
        ascending: true
      });
      
      if (result.error) {
        console.error('Database error getting transcript messages:', result.error);
        return [];
      }

      return result.data || [];
    } catch (error) {
      console.error('Error getting transcript messages:', error);
      return [];
    }
  }
}
